/**
 * Cookie-banner - functionality
 */

window.TV2 = window.TV2 || {};

(function cookieBanner() {
  const bannerEl = document.querySelector('#cookie-banner');
  const cookieKey = 'tv2samtykke';

  /**
   * Check if
   * @returns {string|boolean}
   */
  window.TV2.initCookieBanner = () => {
    const cookie = TV2.getCookieValue(cookieKey);

    if (bannerEl && !cookie) {
      bannerEl.classList.add('cookie-banner--visible');
    }
  };

  /**
   * Handle action to hide banner
   */
  window.TV2.handleCookieBannerClick = () => {
    const cookie = TV2.getCookieValue(cookieKey);
    const cookieValue = cookie ? cookie.split('') : [];
    const loc = window.location.host.split('.');
    const domain = `${loc[loc.length - 2]}.${loc[loc.length - 1]}`;

    cookieValue[0] = '1';

    document.cookie = `${cookieKey}=${cookieValue.join('')}; domain=${domain}; path=/; max-age=${
      60 * 60 * 24 * 365
    }`;

    bannerEl.classList.remove('cookie-banner--visible');
  };
})();
